.chevron {
    img {
        max-width: none;
    }
}